import PropTypes from "prop-types";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

import useAddressStates from "../../PersonDetail/shared/useAddressStates";
import AddEditModalBody from "./AddEditModalBody";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";

const AddEditAddressModal = ({ show, onClose, onSubmit, usedAddresses, initAddress, title, onSaveTxt, hideAddressType, customCancelBtn, showArmedForcesOptions: showArmedForcesOptionsProp }) => {

  const currentUser = useCurrentUser();
  const showArmedForcesOptions = showArmedForcesOptionsProp ?? (currentUser?.account?.country?.trim() === 'US');
  const {
    addressType,
    addressTypes,
    streetAddress,
    secondaryAddress,
    city,
    locality,
    postalCode,
    isLoading,
    error,
    country,
    specificTextInputError,
    setAddressType,
    setStreetAddress,
    setSecondaryAddress,
    setCity,
    setLocality,
    setPostalCode,
    setIsLoading,
    setCountry,
    setError,
    setSpecificTextInputError,
    onCloseHandlr
  } = useAddressStates({ usedAddresses, onClose, initAddress });

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      show={show}
      onHide={onCloseHandlr}
      contentClassName="tw-w-[656px]"
    >
      <Modal.Header
        title={title || "Add Address"}
        className="tw-mb-32px"
        closeButton
      />
      <AddEditModalBody
        addressTypes={addressTypes}
        warningAddressTypeObj={usedAddresses.find((ad) => ad.addressType === addressType && addressType !== "other" && ad.id !== initAddress?.id)}
        setAddressType={setAddressType}
        addressType={addressType}
        setStreetAddress={setStreetAddress}
        streetAddress={streetAddress}
        setSecondaryAddress={setSecondaryAddress}
        secondaryAddress={secondaryAddress}
        city={city}
        setCountry={setCountry}
        country={country}
        setCity={setCity}
        setLocality={setLocality}
        setError={setError}
        locality={locality}
        setPostalCode={setPostalCode}
        postalCode={postalCode}
        error={error}
        specificTextInputError={specificTextInputError}
        hideAddressType={hideAddressType}
        showArmedForcesOptions={showArmedForcesOptions}
        standardized
      />
      <Modal.Footer className="tw-flex tw-flex-row tw-justify-between tw-mt-[32px]">
        {customCancelBtn || (
          <Button schema="tertiary" size="medium" onClick={onCloseHandlr}>
            Cancel
          </Button>
        )}
        <Button disabled={postalCode?.length > 10 || streetAddress?.length > 75 || city?.length > 75} isLoading={isLoading} schema="primary" size="medium" onClick={async () => {
          if (postalCode.trim() === '' || streetAddress.trim() === '' || city.trim() === '') {
            setError("All fields must be filled in to save an address.");

            setSpecificTextInputError({
              streetAddress: streetAddress.trim() === '' ? " " : null,
              city: city.trim() === '' ? " " : null,
              postalCode: postalCode.trim() === '' ? " " : null,
            });

            return;
          }

          setIsLoading(true);
          const response = await onSubmit({
            addressType,
            streetAddress,
            secondaryAddress,
            city,
            locality,
            postalCode,
            country
          });
          setIsLoading(false);

          if (response?.err) {
            setError(response?.err);
            return;
          }

          onCloseHandlr();
        }}>
          {onSaveTxt || "Save"}
        </Button>
      </Modal.Footer>

    </Modal>
  )
};

export default AddEditAddressModal;

AddEditAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  onSaveTxt: PropTypes.string,
  usedAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      addressType: PropTypes.string,
      streetAdress: PropTypes.string,
    })
  ),
  show: PropTypes.bool,
  initAddress: PropTypes.shape({
    id: PropTypes.string,
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    locality: PropTypes.string,
    postalCode: PropTypes.string,
    addressType: PropTypes.string,
  }),
  hideAddressType: PropTypes.bool,
  customCancelBtn: PropTypes.node,
  showArmedForcesOptions: PropTypes.bool,
}

AddEditAddressModal.defaultProps = {
  show: false,
  usedAddresses: [],
  initAddress: {
    streetAddress: "",
    city: "",
    locality: "",
    postalCode: "",
    addressType: ""
  },
  title: null,
  onSaveTxt: null,
  hideAddressType: false,
  customCancelBtn: null,
  showArmedForcesOptions: false,
}
